module.exports = __webpack_public_path__ + "img/bg.0478021d.png";